<button type="button" class="swal2-close" aria-label="Close" (click)="modal.dismiss()">
  <span aria-hidden="true">&times;</span>
</button>

<div class="d-flex flex-column align-items-center p-4">
  <img src="/assets/img/patientlynk/PNG/logo-dark.png" style="max-width: 300px" />
  <span class="my-5" transloco="introModal.copy"
        style="max-width: 60ch; font-size: 1.34rem"></span>

  <div class="mx-auto my-4">
    <input type="checkbox" id="dontShowAgain" (change)="onDontShowAgainChange($event)"
           [ngModel]="(popupSettings | async)?.dontShow"/>
    <label for="dontShowAgain">
      <span transloco="introModal.dontShowAgain">Don't show this next time</span>.
    </label>
  </div>

  <div class="d-flex align-items-center mx-auto">
    <button class="ab_button filled text-nowrap w-auto" (click)="modal.close()">OK</button>
  </div>
</div>
